import Amplify, { Auth as AwsAuth } from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);

class User {
  //isLoggedIn = () => this.get("isLoggedIn") === "true";
  /*
  set = (key, value) => localStorage.setItem(key, value);

  get = (key) => this.getLocalStorage(key);

  getLocalStorage = (key) => {
    const ret = localStorage.getItem(key);
    if (ret) {
      return ret;
    }
    return null;
  };
  */

  login = async (email, password) => {
    try {
      let user = await AwsAuth.signIn(this.idAddDomain(email), password);
      //console.log('成功　サインイン');
      if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        //console.log('エラー　サインイン　パスワードを変更してください。');
        //await AwsAuth.completeNewPassword(user, password);
      }
      return true;
    } catch (error) {
      //if (error.code === 'NotAuthorizedException') {
      //  console.log("エラー　サインイン メールアドレスまたはパスワードが見つかりません。", error);
      //} else if (error.code === 'UserNotFoundException') {
      //  console.log("エラー　サインイン メールアドレスが見つかりません。", error);
      //} else if (error.code === 'UserNotConfirmedException') {
      //  console.log("エラー　サインイン ユーザー認証されていません。", error);
      //} else {
      //  console.log("エラー　サインイン その他", error);
      //}
      return false;
    }
  };

  logout = async () => {
    /*
    if (this.isLoggedIn()) {
      this.set("isLoggedIn", false);
      
      // ログアウト処理
    }
    */
    await AwsAuth.signOut();
  };

  accessToken = async () => {
    const user = await AwsAuth.currentSession();
    return user.accessToken.jwtToken;
  };

  userData = () => {
    const key = [];
    key.push("CognitoIdentityServiceProvider");
    key.push(Amplify.Auth.userPool.clientId);
    key.push(localStorage.getItem(key.join(".") + ".LastAuthUser"));
    key.push("userData");
    const json = JSON.parse(localStorage.getItem(key.join(".")));
    if (json.UserAttributes === null) {
      return false;
    }
    const data = [];
    for (let i in json.UserAttributes) {
      data[json.UserAttributes[i]["Name"]] = json.UserAttributes[i]["Value"];
    }
    return data;
  };
  idAddDomain = (email) => {
    if (email.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
      return email;
    }
    return email + process.env.REACT_APP_LOGIN_ADDDOMAIN;
  }
  isEmailLogin = () => {
    let user = this.userData();
    if (user && user.email.lastIndexOf(process.env.REACT_APP_LOGIN_ADDDOMAIN) === -1) {
      return true;
    }
    return false;
  };
}

export default new User();
